import {forwardRef, HTMLProps} from 'react';

export const Box = forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>((props, ref) => <div {...props} ref={ref}/>);
export default Box;
